import { FieldControl } from "@components/ui/form/FieldControl"
import { useField } from "formik"
import { useMemo } from "react"
import ReCAPTCHA from "react-google-recaptcha"

const Captcha = () => {
  const [, meta, { setValue }] = useField({
    name: "passedCaptcha",
    validate: (value) => (!!value ? undefined : "Please complete the captcha"),
  })
  let errorMsg: undefined | string = undefined
  if (meta.touched && meta.error) {
    errorMsg = meta.error
  }
  const sitekey = useMemo(
    () =>
      // @ts-ignore
      typeof window !== "undefined" && window.Cypress
        ? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" // google test key
        : process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY,
    [],
  )
  if (!sitekey) {
    return null
  }

  return (
    <FieldControl errorMsg={errorMsg} className="mb-5">
      <ReCAPTCHA
        sitekey={sitekey}
        onChange={(value) => {
          setValue(!!value, true)
        }}
        onExpired={() => {
          setValue(false, true)
        }}
      />
    </FieldControl>
  )
}

export default Captcha
